import PropTypes from 'prop-types';
import React from 'react';
import DraftRenderer from '../DraftRenderer/DraftRenderer';
import HotelDetailFeatures from './HotelDetailFeatures';
import HotelDetailPhotos from './HotelDetailPhotos';
import HotelContacts from './HotelContacts';
import DistanceTo from './DistanceTo';
import Landmarks from "./../../routes/hotels/components/Landmarks";
import Rooms from "./../../routes/hotels/components/Rooms"
import moment from "moment";
import { Button } from 'react-bootstrap';
import { monthNameFormatDate } from '../../core/date';

const formatTime = value => {
  if (value) {
    return moment(value, "HH:mm:ss").format("hh:mm A");
  }
};

const displayDate = value => {
  if (value) {
    return monthNameFormatDate(value);
  } else {
    return '';
  }
};

const getDocumentRow = doc => {
  if(doc.is_existing_url) {
    let documentUrl = doc.hotel_document_url;
    let isValidUrl = documentUrl.includes('http');
    if(!isValidUrl) {
      documentUrl = 'http://' + documentUrl;
    }
    return (
            <p>
              <span className="hote-document-row">
                {doc.document_name}
              </span>
              &nbsp;&nbsp;
              <a 
                title="Open in new tab" 
                bsStyle="success" 
                target="_blank" 
                href={documentUrl}>
                <i 
                  className="fa hotel-document-ext-link fa-external-link" 
                  aria-hidden="true">
                </i>
              </a>
            </p>
        );
  }else {

    let hotelDocument = doc.hotel_document;
    return (
            <p>
              <span className="hote-document-row">
                {doc.document_name}
              </span>
              &nbsp;&nbsp;
              <a 
                title="Download document" 
                bsStyle="success"
                target="_blank"
                href={hotelDocument}>
                <i 
                  className="fa hotel-document-ext-link fa-download" 
                  aria-hidden="true">
                </i>
              </a>
            </p>
        );
  }
}

class HotelDetail extends React.Component {
  render() {
    const hotelDocuments = [];
    const taxFormatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 2,
    });

    const { hotel } = this.props;
    const taxRate = taxFormatter.format(hotel.tax_rate);
    const checkIn = formatTime(hotel.check_in);
    const checkOut = formatTime(hotel.check_out);
    const builtDate = displayDate(hotel.year_built);
    const remodeledDate = displayDate(hotel.year_remodeled);

    if(hotel.documents) {
      hotel.documents.forEach((doc)=>{
        const documentRow = getDocumentRow(doc);
        hotelDocuments.push(documentRow);
      });
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h1>{hotel.name}</h1>
            {hotel.brand && <h3>{hotel.brand.name}</h3>}
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <div className="hotel-distance">
              <p>
                {hotel.stars ? hotel.stars : '?'}
                <i className="fa fa-star" />
                <a
                  href={hotel.website}
                  title={hotel.website}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ marginLeft: 8 }}
                >
                  <span className={hotel.website ? 'fa fa-external-link' : 'hidden'} />
                </a>
              </p>
            </div>
            <p>
              <i className="fa fa-map-marker" />
              {hotel.address}, {hotel.locality}, {hotel.region} {hotel.postcode}
            </p>
            <DistanceTo {...this.props.distanceTo} />
            <p>
              <i className="fa fa-phone" style={{ marginRight: 8 }} />
              {hotel.tel}
            </p>
          </div>
          <div className="col-md-4">
            <HotelContacts hotel={hotel} />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-12 hotel-details-description">
            <h4 className="hotel-highlight">Property Description</h4>
            <DraftRenderer raw={hotel.description} placeholder="No property description." />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 hotel-special-offer-section">
            <h4 className="hotel-highlight hotel-special-offer-label">Special Offer</h4>
            <p className="hotel-special-offer">{hotel.special_offer}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 hotel-details-description">
            <h4 className="hotel-highlight">Hotel Document(s)</h4>
              {hotelDocuments.length ? hotelDocuments : (<p className="hote-document-row">No hotel document(s) available.</p>)}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4 className="hotel-highlight">Details</h4>
          </div>
          <div className="col-md-3">
            <p>AAA Rating: {hotel.stars}</p>
            <p>Check-in Time: {checkIn}</p>
            <p>Check-out Time: {checkOut}</p>
            <p>Number of Rooms: {hotel.room_count}</p>
            <p>Number of Floors: {hotel.floors}</p>
          </div>
          <div className="col-md-3">
            <p>Restaurant Hours: {hotel.is_24hours_restaurant ? '24 Hours' : ((hotel.restaurant_from_time && hotel.restaurant_to_time) ? `${formatTime(hotel.restaurant_from_time)} to ${formatTime(hotel.restaurant_to_time)}` : 'NA')}</p>
            <p>Bar Hours: {hotel.is_24hours_bar ? '24 Hours' : ((hotel.bar_from_time && hotel.bar_to_time) ? `${formatTime(hotel.bar_from_time)} to ${formatTime(hotel.bar_to_time)}` : 'NA')}</p>
            <p>Gym Hours: {hotel.is_24hours_gym ? '24 Hours' : ((hotel.gym_from_time && hotel.gym_to_time) ? `${formatTime(hotel.gym_from_time)} to ${formatTime(hotel.gym_to_time)}` : 'NA')}</p>
            <p>Room Service Hours: {hotel.is_24hours_room_service ? '24 Hours' : ((hotel.room_service_from_time && hotel.room_service_to_time) ? `${formatTime(hotel.room_service_from_time)} to ${formatTime(hotel.room_service_to_time)}` : 'NA')}</p>
          </div>

          <div className="col-md-3">
            <p>Currency: {hotel.currency}</p>
            <p>Tax Rate: {taxRate}</p>
            <p>Additional Tax(per day): {hotel.currency}&nbsp;{hotel.additional_tax}</p>
            <p>Resort Fee(per day): {hotel.currency}&nbsp;{hotel.resort_fee}</p>
          </div>
          <div className="col-md-3">
            <p>Date Built:  {builtDate}</p>
            <p>Date Remodeled: {remodeledDate}</p>
         </div>

          <div className="col-md-12">
            <h4 className="hotel-highlight">Bus Parking</h4>
          </div>
          <div className="col-md-12">
            <p>Capacity: {hotel.bus_capacity}</p>
            <p>Parking Charges: {hotel.parking_charges} &nbsp;&nbsp; per:{hotel.per_day_night == 1 ? ' per day' : hotel.per_day_night == 2 ? ' per night' : ''}</p>
            <p>Notes: {hotel.bus_parking}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4 className="hotel-detail-subhead">Photos</h4>
          </div>
        </div>
        <div className="row">
          <HotelDetailPhotos photos={hotel.photos} />
        </div>
        <div className="row">
          <div className="col-md-12">
            <h4 className="hotel-detail-subhead">Amenities</h4>
            <div className="row">
              <HotelDetailFeatures features={this.props.hotel.features} />
            </div>
          </div>
        </div>
        <div className="row">
          <Landmarks hotel={hotel} isHotelView={true}/>
        </div>
        <div className="row">
          <Rooms hotel={hotel}
            sortHotelPhotos={this.props.sortHotelPhotos}
            removeHotelPhoto={this.props.removeHotelPhoto}
            editHotelPhoto={this.props.editHotelPhoto}
            removeRoomType={this.props.removeRoomType}
            editHotel={this.props.editHotel}
            editRoomtypes={this.props.editRoomtypes}
            addHotelAddRoomType={this.props.addHotelAddRoomType}
            addAddHotelRoomPhoto={this.props.addAddHotelRoomPhoto}
            removeRoomPhoto={this.props.removeRoomPhoto}
            isHotelView={true}
          />
        </div>
      </div>
    );
  }
}

HotelDetail.propTypes = {
  hotel: PropTypes.object.isRequired,
  distanceTo: PropTypes.object,
};
HotelDetail.defaultProps = {
  distanceTo: null,
};

export default HotelDetail;



// WEBPACK FOOTER //
// src/components/HotelDetail/HotelDetail.js